<template>
  <component
    :is="tag"
    :type="type"
    :class="classList"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <span>
      <slot />
    </span>
    <div
      v-if="loading"
      class="lds-ring"
    >
      <div /><div /><div /><div />
    </div>
  </component>
</template>

<script>
export default {
  name: 'HButton',
  props: {
    tag: {
      type: String,
      default: 'button',
    },

    type: {
      type: String,
      default: 'button',
    },

    size: {
      type: String,
      default: 'default',
    },

    btnClass: {
      type: String,
      default: 'btn-primary',
    },

    fullWidth: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classList() {
      return [
        'btn',
        this.btnClass,
        {
          'w-100': this.fullWidth,
          loading: this.loading,
        },
        {
          'is-small': this.size === 'small',
        },

      ];
    },
  },
};
</script>

<style lang="scss" scoped>
  .btn {
    position: relative;
    box-sizing: border-box;
    border: none;
    border-radius: 5px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;
    font-size: 12px;
    padding: 0 30px;
    font-family: var(--font-bold);
    text-decoration: none;
    text-align: center;
    text-transform: uppercase;
    overflow: hidden;

    &.is-small {
      height: 38px;
      padding: 0 20px;
      font-size: 11px;
    }

    .lds-ring {
      position: absolute;
      top: 24px;
      transform: translateY(-50%);
    }

    &:disabled {
      opacity: 0.3;
      cursor: default;
    }

    &:hover {
      text-decoration: none;
    }

    &:active {
      transform: scale(0.95);
    }

    &:focus {
      outline: none !important;
      box-shadow: none !important;
    }

    &.loading {
      opacity: 0.5;

      span {
        opacity: 0.3;
      }
    }

    &.btn-default {
      background: #212932;
      color: var(--color-white);

      &:hover {
        background: #2c3744;
      }
    }

    &.btn-primary {
      background: linear-gradient(180deg, #ffa33c 0%, #f78300 109.46%);
      color: var(--color-white);

      &:hover {
        background: linear-gradient(180deg, #f78300 109.46%, #ffa33c 0%);
      }
    }

    &.btn-success {
      background: var(--color-success-300);
      color: var(--color-white);

      &:hover {
        background: var(--color-success-100);
      }

      &:active {
        background: var(--color-success-300);
      }
    }

    &.btn-link {
      background: none;
      color: var(--color-grey);

      &:hover {
        color: var(--color-secondary);
      }

      // &:active {
      //   background: var(--color-secondary-200);
      // }
    }

    &.btn-danger {
      background: var(--color-danger);
      color: var(--color-white);

      // &:hover {
      //   background: var(--color-secondary-100);
      // }

      // &:active {
      //   background: var(--color-secondary-200);
      // }
    }

    &.btn-tertiary {
      background: var(--color-white);
      color: var(--color-primary);
      border-color: var(--color-primary-100);
      border: 2px var(--color-primary-100) solid;
      max-width: 260px;
      line-height: 17px;
      font-size: 14px;
      padding: 0 40px;

      &:hover {
        border-color: var(--color-primary-300);
      }

      &:active {
        background: var(--color-primary-100);
      }
    }

    &.btn-white {
      background: var(--color-white);
      color: var(--color-primary);

      &:hover {
        background: var(--color-primary-100);
      }

      &:active {
        color: var(--color-secondary);
      }
    }

    &.change-game-btn {
      margin-top: 20px;
      background: none;
      color: var(--color-white);
      font-size: 14px;
      font-family: var(--font-bold);
      border: 2px solid var(--color-white);
      height: 36px;
      border-radius: 5px;
      padding: 0 15px;
      transition: 0.2s;

      &:hover {
        background: var(--color-white);
        color: var(--color-secondary);
      }
    }

    &.small-btn {
      height: 30px;
      padding: 0 10px;
    }

    &.w-100 {
      width: 100%;
    }
  }
</style>
